import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Li, paletteHelper, Text, typographyHelper, Ul } from '@property.com.au/ui-kit';

const Wrapper = styled.div`
  color: ${paletteHelper('textSecondary')};
  font: ${typographyHelper('body01')};
`;

export const GovernmentOverlaysBrickInformationModalContent: FunctionComponent = () => {
  return (
    <Wrapper>
      <Text>Planning, zones and overlays data aims to provide clarity on the following:</Text>
      <br />
      <Ul>
        <Li>Which local government the property resides in</Li>
        <Li>What the land is permitted to be used for</Li>
        <Li>
          If there is an overlay that may require further consideration in terms of development
          applications
        </Li>
      </Ul>
      <br />
      <Text>
        What we display is an indication that an overlay may or may not intersect the land. When an
        overlay intersects with the land on which the property resides, planning controls may apply
        if a development application is lodged with your local council. It is important to note that
        they are not intended to represent a property’s risk.
      </Text>
      <br />
      <Text>
        Councils have different conditions on what will trigger requirements for planning and
        development applications.
      </Text>
      <br />
      <Text>
        Your local council will be able to provide clarification or additional information related
        to your property if there are any concerns.
      </Text>
      <br />
      <Text>
        If this results in changes to the data our data provider will send us the new information.
        Currently data is updated quarterly, and we aim to update our site soon after it is received
      </Text>
    </Wrapper>
  );
};
